<template>
    <section class="general-modal">
        <h1 class="modal-title"> Questions fréquentes </h1>
        <h2>Notre garantie sérénité</h2>
        <p>Chez Testachats, pas question de vous garder lié à un abonnement contre votre volonté. Grâce à notre garantie de satisfaction, vous êtes libre de mettre fin à votre affiliation quand vous le souhaitez. Il vous suffira de nous en avertir au plus tard 15 jours ouvrables avant chaque échéance mensuelle de votre abonnement*. Il n'y a donc pas d'obligation d'achat définitif puisque vous pouvez annuler votre abonnement à votre gré sans devoir nous fournir la moindre explication. *Attention: tout mois entamé est considéré comme un mois entier.
        </p>

        <h2>Combien coûte l'abonnement ?</h2>
        <p>Vous bénéficierez d’une réduction exceptionnelle de 50 % pour votre première année d’abonnement, soit seulement 9,84 euros par mois au lieu de 19,82 euros.</p>
        <p>De plus, en guise de remerciement pour votre fidélité, après 6 mois d’abonnement, nous vous rembourserons 3 mois, soit un montant de 29,52 euros. Une façon pour nous de vous remercier et de vous aider à profiter pleinement de nos services.</p>
        <p>Avec Testachats, vous pouvez économiser bien plus que le coût de votre abonnement grâce à nos conseils et services personnalisés !</p>

        <h2>Plus d'informations sur les modalités d'affiliation</h2>
        <p>Vous pouvez résilier votre affiliation par e-mail, simple lettre ou par un appel téléphonique 15 jours ouvrables avant la fin de chaque échéance mensuelle.</p>

        <h2>Ce site web est-il sécurisé  ?</h2>
        <p>Chez Testachats, votre sécurité est notre priorité n°1. Nous vous garantissons donc que chaque paiement sera sécurisé. Nous utilisons, en effet, une technologie performante : un serveur sécurisé (SSL) qui assure la fiabilité de notre commerce en ligne. Ce logiciel crypte toutes vos données personnelles indispensables au traitement de vos commandes (nom, adresse, coordonnées bancaires) au moment de leur saisie. Ce système empêche la lecture de vos informations lors de leur unique transfert d'Internet à notre site.</p>

        <h2>Comment puis-je contacter Testachats ?</h2>
        <p>Pour nous contacter, vous pouvez soit adresser une lettre à Testachats, rue de Hollande 13, 1060 Bruxelles, soit envoyer un e-mail via <a href="https://www.testachats.be/contact" target="_blank">www.testachats.be/contact</a>, soit téléphoner au service clientèle au<a href="tel:02/892 37 01">02/892 37 01</a>.</p>

        <h2>Puis-je lire mes magazines de façon digitale sur mon smartphone ?</h2>
        <p>Oui, nos magazines Testachats et Test Santé sont disponibles en version digitale. Vous les trouverez sur la page <a href="https://testachats.be/applications" target="_blank">testachats.be/applications</a>.</p>
    </section>
</template>

<script>
export default {
    name: "FaqModal"
}
</script>

<style scoped>

</style>
